
import React from 'react'

function AvailbleCard() {
    return (
        <div className='bg-lightYellow lg:px-10 px-2 py-4 shadow-xl rounded'>
            <div className='text-center text-gray text-base sm:text-lg lg:text-xl 2xl:text-2xl'>
                We are available 24 hours a day, 365 days a year (including Christmas Day) guaranteeing our passengers a safe and efficient service all year round.
            </div>
        </div>
    )
}

export default AvailbleCard